export const TabIds = {
  INFORMATION: 'information',
  CONTACT: 'contact',
  DELIVERY: 'delivery',
  PAYMENT: 'payment',
  REVIEW: 'review',
};
